import { Button } from 'antd'
import React, { useEffect, useRef } from 'react'
import { OptModelTypeEnum } from '@components/YHDict/Types'
import { YHDict } from '@components/YHDict'
import { FormItemTypeEnum, IFormItem, IYhFormRef } from '@components/YhFormBox/Types'
import { useOrgModel } from './orgModel'
import { BranchDs } from '@src/types/FmsDs'

export const BaseOrg = () => {
  const formRef = useRef<IYhFormRef>()
  const {
    selectedData,
    syncData,
    getTreeData,
    dataSource,
    optModelType,
    setSelectedRowKeys,
    setSelectParentData,
    setSelectedData,
    setOptModelType,
    loadData,
    // loadOneData,
  } = useOrgModel()

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const [peerAndSon, setPeerAndSon] = useState(-1)
  // useEffect(() => {
  //   formRef.current?.resetFields();
  //   setPeerAndSon(optModelType)
  // }, [selectedData])

  const items: IFormItem[] = [
    {
      type: FormItemTypeEnum.Select,
      fieldLabel: "分支",
      fieldName: "branch",
      ds: BranchDs,
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "数据版本号",
      fieldName: "ver",
      span: 13,
      disable: true,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "编码",
      fieldName: "code",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "名称",
      fieldName: "name",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系人",
      fieldName: "contact",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系电话",
      fieldName: "phone",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系地址",
      fieldName: "address",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "备注",
      fieldName: "note",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Switch,
      fieldLabel: "状态",
      fieldName: "enable",
      valuePropName: "checked",
      span: 13,
    },
    // {
    //   type: FormItemTypeEnum.Input,
    //   fieldLabel: "从属机构",
    //   fieldName: "pcode",
    //   span: 13,
    //   hidden: !selectedData?.pcode,
    // },





  ]

  const action = <>
    {/* <Button
      className="mr-5"
      type="link"
      shape="round"
      disabled={selectedRowKeys.length === 0}
      onClick={() => onAddPeer()}
    >增加同级</Button>
    <Button
      className="mr-5"
      type="link"
      shape="round"
      disabled={selectedRowKeys.length === 0}
      onClick={() => onAddSon()}
    >增加下级</Button>
    <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => remove()}
        >删除</Button> */}
    <Button
      className="mr-5"
      type="link"
      shape="round"
      onClick={loadData}
    >刷新</Button>
    <Button
      className="mr-5"
      type="link"
      shape="round"
      onClick={syncData}
    >同步</Button>
  </>


  const onSubmit = async () => {
    try {
      // const formData = await formRef.current?.validateFields();
      // if (formData) {
      //   const params = {
      //     ...formData,
      //     enable: formData.enable ? 1 : 0,
      //   }
      //   if (optModelType === OptModelTypeEnum.ADD_ROOT || optModelType === OptModelTypeEnum.ADD_CHILD_LEVEL) {
      //     const insertRet = await orgService.insert(params);
      //     if (insertRet.success) {
      //       await globalPrompt("message", { type: "success", text: '新增成功!' });
      //       await loadData();
      //     } else {
      //       await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
      //     }
      //   }
      //   if (optModelType === OptModelTypeEnum.DETAIL) {
      //     const updateRet = await orgService.update(params);
      //     if (updateRet.success) {
      //       await globalPrompt("message", { type: "success", text: '修改成功!' });
      //       await loadData();
      //     } else {
      //       await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
      //     }
      //   }
      // }
    } catch (e) {
      console.log("失败!");
    }
  }

  const onCancel = () => {

  }

  const onReset = () => {
    // formRef.current?.resetFields()
  }

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    const selectedNode = info.selectedNodes[0];
    const pNode = dataSource.find(item => item.code === selectedNode?.pcode)
    setSelectParentData(pNode)
    setSelectedData(selectedNode.el)
    setSelectedRowKeys(selectedKeys)
    setOptModelType(OptModelTypeEnum.DETAIL)
  }

  return (
    <YHDict
      // form
      formTitle="机构详情"
      items={items}
      optModelType={optModelType}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onReset={onReset}
      initialValues={{
        ...selectedData,
        enable: selectedData?.enable === 1
      }}
      formRef={formRef}
      disabled={true}

      // tree
      treeTitle="机构目录"
      action={action}
      treeData={getTreeData()}
      onSelect={onSelect}
    />
  )
}